import React, { Component } from "react";
import { Text } from "react-internationalization";
import history from "../../Utils/History";
import SignaturePad from "react-signature-canvas";
import PreviewPageStep1 from "../PreviewPageStep1";
import PreviewPageStep2 from "../PreviewPageStep2";
import PreviewPageStep3 from "../PreviewPageStep3";
import { saveAs } from "file-saver";
import { pdf } from "@react-pdf/renderer";
import { connect } from "react-redux";
import SoaDocument from "../soapdf/SoaDocument";
import { PDFDownloadLink } from "@react-pdf/renderer";
import {
  deleteFile,
  downloadFormsPdf,
  getPcpList,
  setStateParams,
  fetchFileTypes,
} from "../../Redux/Actions/webAppActions";
import { INITIAL_STATE } from "../initialState";
import AutoComplete1 from "../../Utils/GenericUI/Select";
import { VERDA_CONSTS, NEBRASKA_CONSTS, ILS_CONSTS } from "../../Utils/StaticData/Constant";
const categoryOptions = [
  { label: "Select", value: "" },
  { label: "E-ENROLLMENT AGENT", value: "E-ENROLL AGENT" },
  { label: "E-ENROLLMENT TELEPHONE", value: "E-ENROLL TELEPHONE" },
];
class Step4Agent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ready: false,
    };
    this.sigPad = {};
  }
  async componentDidMount() {
    if (
      this.props.data.permanentAddrStreet &&
      this.props.data.permanentCity &&
      this.props.data.permanentZip &&
      this.props.physiciansData.length <= 1
    ) {
      await this.props.getPcpList({
        address: this.props.data.permanentAddrStreet,
        city: this.props.data.permanentCity,
        zipCode: this.props.data.permanentZip,
        distance: "100",
        customerId: this.props?.customerId,
      });
    }
    // if (this.props.data.agentSign !== "") {
    //   var canvas = document.getElementById("sigCanvas");
    //   var context = canvas.getContext("2d");
    //   var img = new Image();
    //   img.src = this.props.data.agentSign;
    //   img.onload = function () {
    //     context.drawImage(this, 0, 0);
    //   };
    // }
    // for (let i = 0; i < this.props.data?.attachmentList?.length; i++) {
    //   if (this.props.data?.attachmentList[i]?.attachmentType === "SIGNATURE") {
    //     await this.props.saveSign(this.sigPad.fromDataURL(this.props.data?.attachmentList[i]?.sign), false);
    //     let image = new Image();
    //     image.src = this.props.data?.attachmentList[i]?.sign;
    //     document.getElementById("sigImg").replaceChildren()
    //     document.getElementById("sigImg").appendChild(image)
    //     return;
    //   }
    // }
    // if (this.props.data.agentSign) {
    //   let image = new Image();
    //   image.src = this.props.data.agentSign;
    //   document.getElementById("sigImg").replaceChildren()
    //   document.getElementById("sigImg").appendChild(image)
    // }
    await this.props.fetchFileTypes();
  }
  downloadPdf = async (e) => {
    let pdfs = this.props.data.pdfBlobs.filter(
      (b) => b.attachmentType === e.target.id
    )[0].attachment;
    if (pdfs !== null) {
      saveAs(pdfs, `${e.target.id}`);
    } else {
      //this.props.openSnackBar("Cannot download the file","error")
      let attachmentType;
      let pdfname = `${e.target.id}` + ".pdf";
      if (`${e.target.id}` === "COORDINATION OF CARE") {
        attachmentType = "CC";
      } else {
        attachmentType = "PEP";
      }
      const payload = {
        appNumber: this?.props?.appNum,
        customerId: this?.props?.customerId,
        attachmentType: attachmentType,
      };
      const response = await this?.props.downloadFormsPdf(payload);
      if (response.status === "OK") {
        const blob = "data:application/pdf;base64," + response.data;
        saveAs(blob, pdfname);
      }
    }
    // else{
    //  this.props.openSnackBar("Cannot download the file","error")
    // }
  };
  clear = async () => {
    for (let i = 0; i < this.props.data?.attachmentList?.length; i++) {
      if (this.props.data?.attachmentList[i]?.attachmentType === "SIGNATURE") {
        const appNumber = this.props.pendingApplFlag
          ? // authenticatedData.pendingAppNum
            this.props?.appNum
          : this.props.guestbeneagentAppNum
          ? this.props.guestbeneagentAppNum
          : this.props.count
          ? this.props.count
          : null;
        await this.props.deleteFile({
          appNumber: appNumber,
          attachmentId: this.props.data?.attachmentList[i]?.attachmentId,
          attachmentName: this.props.data?.attachmentList[i]?.attachmentName,
          customerId: this.props?.customerId,
        });
      }
    }
    this.sigPad.clear();
    this.props.clear();
    document.getElementById("sigImg").replaceChildren();
  };
  save = () => {
    this.props.saveSign(
      this.sigPad.getTrimmedCanvas().toDataURL("image/png"),
      true
    );
    let bse65Img = this.sigPad.getTrimmedCanvas().toDataURL("image/png");
    document.getElementById("sigImg").replaceChildren();
    if (
      bse65Img !==
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAAtJREFUGFdjYAACAAAFAAGq1chRAAAAAElFTkSuQmCC"
    ) {
      let canvasEle = this.sigPad.getTrimmedCanvas();
      let image = new Image();
      image.src = canvasEle.toDataURL();
      document.getElementById("sigImg").replaceChildren();
      document.getElementById("sigImg").appendChild(image);
    }
  };
  // soaPdf = async () => {
  //   const blob = await pdf(
  //     <SoaDocument
  //       pdfData={this.props.SOApdf}
  //       flag={true}
  //       component="fullrelation"
  //       selectedPlanName={this.props.selectedPlanName}
  //       authorizedrelations={this.props.authorizedrelations}
  //     />
  //   ).toBlob();
  //   saveAs(blob, "Soa.pdf");
  // };
  soaPdf = async () => {
    let blob;
    if (
        [
            NEBRASKA_CONSTS.ID,
            VERDA_CONSTS.ID,
            ILS_CONSTS.ID
          ]
          .some((ids)=>ids===this?.props?.customerId)    
    ) {
      const payload = {
        appNumber: this?.props?.count,
        customerId: this?.props?.customerId,
        attachmentType: "SOA",
      };
      const response = await this?.props.downloadFormsPdf(payload);
      if (response.status === "OK") {
        blob = "data:application/pdf;base64," + response.data;
        //const blob = await pdf(response.data).toBlob();
        saveAs(blob, "Soa.pdf");
      }
      return;
      // console.log("clssoadata",this.props.SOApdf)
      // let payload={
      //   leadIdNbr:"",
      //   customerId:this?.props?.customerId,
      //   beneRepSignature:this.props.SOApdf?.repSignature,
      //   beneRepSignDate:this.props.SOApdf?.repDate,
      //   relationshipToBene:this.props.SOApdf?.repRelationShip,
      //   repName:this.props.SOApdf?.repName,
      //   productName:this.props.SOApdf?.productIds,
      //   agentName:this.props.SOApdf?.agentName,
      //   agentPhone:this.props.SOApdf?.agentPhone,
      //   agentSign:this.props.SOApdf?.agentSignutre,
      //   appointmentDateComp:this.props.SOApdf?.dateApntmntCmpltd,
      //   beneName:this.props.SOApdf?.beneficiaryName,
      //   benePhone:this.props.SOApdf?.beneficiaryPhone,
      //   beneAddress:this.props.SOApdf?.beneficiaryAddress,
      //   initialMethodOfContact:this.props.SOApdf?.initialMethodOfContact,
      //   captureBeneRepSign:"",
      //   salesChannelOth:this.props.SOApdf?.salesChannelOth,
      // }
      // await this.props.SoapdfDownload(payload)
    } else {
      blob = await pdf(
        <SoaDocument
          pdfData={this.props.SOApdf}
          flag={true}
          component="fullrelation"
          selectedPlanName={this.props.selectedPlanName}
          authorizedrelations={this.props.authorizedrelations}
        />
      ).toBlob();
    }
    saveAs(blob, "Soa.pdf");
  };
  render() {
    const { data, planName, uploadFiles1 } = this.props;
    uploadFiles1.filter((attachment) => attachment.value !== "");
    console.log("typeOfFilesToUpload-",this.props.typeOfFilesToUpload)
    return (
      <React.Fragment>
        <div
          class={
            data?.appStatus === "READY" || data?.appStatus === "SUBMITTED"
              ? "tab-content tab-contentSharp disable-form"
              : "tab-content tab-contentSharp"
          }
        >
          <div id="step4" class="container-Cambia tab-pane active">
            <h3 class="tab-heading mb-3">
              <Text id="step4Agent.step4" /> – <Text id="step4Agent.heading" />
            </h3>
            <label class="control-label mt-3 mb-3">
              <strong>{planName}&nbsp;</strong>
            </label>
            <PreviewPageStep1
              data={this.props.data}
              changeToSection1={this.props.changeToSection1}
              authorizedrelations={this.props.authorizedrelations}
            />
            <PreviewPageStep2
              data={this.props.data}
              changeToSection2={this.props.changeToSection2}
              selectedAttestation={this.props.selectedAttestation}
            />

            <PreviewPageStep3
              pcpName={this.props.pcpName}
              PcpLocationId={this.props.PcpLocationId}
              data={this.props.data}
              changeToSection3={this.props.changeToSection3}
            />

            <div class="mt-2">
              <label for="nameSignature" class="control-label">
                <strong><Text id="step3.attacheddoc"/></strong>
              </label>
              <div class="row">
                <div class="mr-3 ml-3">
                  <a class="anchrhiglighted" onClick={() => this.soaPdf()}>
                    SOA
                  </a>
                </div>
                {this.props.data?.pdfBlobs?.length > 0 && (
                  <>
                    {this.props.data.pdfBlobs.map((f) => (
                      <div class="mr-3 col-12" key={f.attachmentType}>
                        <a
                          class="anchrhiglighted"
                          id={f.attachmentType}
                          onClick={(e) => this.downloadPdf(e)}
                        >
                          {f.attachmentType}
                        </a>
                      </div>
                    ))}
                  </>
                )}
              </div>
            </div>
            {/* )} */}

            <div class="mt-3">
              <label class="control-label" for="fileUpload">
                <Text id="step4Agent.fileUpload" />
              </label>
              <div class="card">
                <div className="card-header file-upload-container-aligner display-inline-flex">
                  <div class="select-file-typeSetp">
                    <label
                      class="control-label select-filetype-label-setp"
                      for="fileType"
                    >
                      <Text id="step4Agent.sfiletype" />
                    </label>
                    <select
                      name="fileType"
                      id="fileType"
                      class={"form-control"}
                      value={this.props.fileType}
                      onChange={this.props.handleChange}
                    >
                      <>
                      <option
                      class="select-option"
                      value={""}
                      >
                        Select
                      </option>
                      {this.props.typeOfFilesToUpload.map((item, i) => {
                        return (
                          <option
                            class="select-option"
                            value={item.attachmentType}
                            key={i}
                          >
                            {item.attachmentDesc}
                          </option>
                        );
                      })}
                      </>
                    </select>
                  </div>
                  <div className="file-upload-aligner file-upload-container">
                    <label
                      className={
                        this.props.fileType === ""
                          ? "btn btn-secondary"
                          : "btn btn-primary"
                      }
                    >
                      <input
                        type="file"
                        name="fileUpload"
                        id="fileUpload"
                        class="display-none"
                        onChange={this.props.handleChange}
                        onClick={(event) => (event.target.value = "")}
                        disabled={this.props.fileType === "" ? true : false}
                      />
                      <i className="fa fa-upload" aria-hidden="true"></i>&nbsp;
                      <Text id="step4Agent.uploadFile" />
                    </label>
                  </div>
                </div>
                <div class="panel">
                  <div class="card-body">
                    {this.props.selectedFiles.map(
                      (file, index) =>
                        file.attachmentType !== "SIGNATURE" &&
                        file.attachmentType !== "ENROLLMENT" &&
                        file.attachmentType !== "SOA" && (
                          <div class="row">
                            <p class="col-md-3">
                              {file?.name || file?.attachmentType}
                            </p>
                            <a
                              href={this.props.url}
                              target="_blank"
                              class="col-md-5 anchrhiglighted"
                              onClick={(e) =>
                                this.props.viewFile(
                                  index,
                                  file.name || file.attachmentName,
                                  e
                                )
                              }
                            >
                              {file?.File?.name || file?.attachmentName}
                            </a>
                            <p class="col-md-2">
                              {file && file.File
                                ? `${file.File.size / 1024} kb`
                                : ""}{" "}
                            </p>
                            <a
                              class="col-md-2 cursor-pointer"
                              onClick={() =>
                                this.props.removeFile(
                                  index,
                                  file.name || file.attachmentName
                                )
                              }
                            >
                              <i className="fa fa-times" aria-hidden="true"></i>
                            </a>
                          </div>
                        )
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-3">
              {this.props.preEnrollInfo?.appStatus != "READY" &&
                this.props.preEnrollInfo?.appStatus != "SUBMITTED" && (
                  <button
                    class="btn btn-saveNext"
                    id={this.props.id ? this.props.id : "next4"}
                    onClick={this.props.redirect}
                    style={{ backgroundColor: "#603167" }}
                    disabled={
                      this.props?.Submitted ||
                      this.props.preEnrollInfo?.appStatus === "READY" ||
                      this.props.preEnrollInfo?.appStatus === "SUBMITTED"
                    }
                  >
                    <Text id="app.Save_Next" />
                  </button>
                )}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    preEnrollInfo: state.webApp.preEnrollInfo,
    firstName: state.login.firstName,
    lastName: state.login.lastName,
    agentId: state.login.agentId,
    stateCd: state.webApp.stateCd,
    physiciansData: state.webApp.physiciansData,
    selectedPlanName: state.login.selectedPlanName,
    Submitted: state.webApp.Submitted,
    appNum: state.webApp.appNum,
    guestbeneagentAppNum: state.webApp.guestbeneagentAppNum,
    count: state.webApp.count ? state.webApp.count : state.webApp.appNum,
    pendingApplFlag: state.webApp.pendingApplFlag,
    deeplink: state.login.deeplink,
    stateId: state.webApp.stateId,
    SOApdf: state.webApp.soa,
    customerId: state.login.customerId,
  };
};
const mapDispatchToProps = {
  deleteFile,
  downloadFormsPdf,
  getPcpList,
  setStateParams,
  fetchFileTypes,
};
export default connect(mapStateToProps, mapDispatchToProps)(Step4Agent);
